import { Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import { useTenant } from "../tenant/TenantContext";
import { ROLE_LABELS } from "../api/types";
import { Badge, ErrorState, LoadingState } from "../components/ui";
import { MockBanner } from "../components/MockBanner";

// Só lista os vínculos retornados pela sessão; não existe caminho para
// escolher um tenant arbitrário por URL ou entrada manual.
export function TenantSelectPage() {
  const auth = useAuth();
  const tenant = useTenant();
  const navigate = useNavigate();

  if (auth.status === "signed_out") return <Navigate to="/login" replace />;
  if (tenant.sessionStatus === "ready" && tenant.memberships.length <= 1) {
    // Com um único vínculo a seleção não aparece: entra direto.
    return <Navigate to="/" replace />;
  }

  return (
    <>
      <MockBanner />
      <main className="tenant-select">
        <div className="tenant-select-card">
          <div>
            <span className="eyebrow">AVA REMOTA</span>
            <h1>Escolha o condomínio</h1>
            <p>Você administra mais de um condomínio. Selecione qual deseja gerenciar agora.</p>
          </div>
          {tenant.sessionStatus !== "ready" ? (
            <LoadingState label="Carregando seus condomínios…" />
          ) : (
            tenant.memberships.map((membership) => (
              <button
                key={membership.tenant_id}
                type="button"
                className="tenant-option"
                onClick={() => {
                  if (tenant.selectTenant(membership.tenant_id)) navigate("/", { replace: true });
                }}
              >
                <span>
                  <strong>{membership.tenant_name}</strong>
                  <small>{ROLE_LABELS[membership.role]}</small>
                </span>
                {tenant.activeMembership?.tenant_id === membership.tenant_id && (
                  <Badge tone="ok">Atual</Badge>
                )}
              </button>
            ))
          )}
          {tenant.sessionStatus === "error" && (
            <ErrorState error={new Error(tenant.sessionError ?? "Falha ao carregar a sessão.")} onRetry={tenant.refetchSession} />
          )}
          <button type="button" className="link" onClick={tenant.signOut}>Sair</button>
        </div>
      </main>
    </>
  );
}
